// extracted by mini-css-extract-plugin
export var faq__item = "faq-module--faq__item--qkNnp";
export var faq__item_active = "faq-module--faq__item_active--TDxWy";
export var faq__answer = "faq-module--faq__answer--pFUa3";
export var faq__cross = "faq-module--faq__cross--fazhM";
export var faq__button = "faq-module--faq__button--DaOUp";
export var faq__question = "faq-module--faq__question--3ASdL";